import React, { useState, useEffect } from "react";
import Header from "../components/header";
import markersection from "../assets/promotionmaker/1.png";
import { PersistGate } from "redux-persist/integration/react";
import img1 from "../assets/promotionmaker/1.webp";
import img2 from "../assets/promotionmaker/2.webp";
import img3 from "../assets/promotionmaker/3.webp";

import img4 from "../assets/promotionmaker/2.png";
import img5 from "../assets/promotionmaker/3.png";
import img6 from "../assets/promotionmaker/3.png";

import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import { NavLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { LazyLoadComponent, LazyLoadImage } from "react-lazy-load-image-component";
import api from "../config/api";  // Fixed import path

const Catelog = () => {
  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${img1}`);

  // Function
  const [menu, setMenu] = useState("");
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api.API_URL}/aapi/tempbycat.php?title=Promotion Maker`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header menu={menu} setMenu={setMenu} />
      <div onMouseOver={() => handleMouseOver("")} className="text-black"></div>
      <div className="pt-20 bg-purple-500">
        <div className="grid grid-cols-2 p-5">
          <div className="p-10 ml-5 text-white text-[16px] font-[100px]">
            <p className="text-4xl font-semibold">Pushing The Boundaries To Frame Extraordinary Experiences</p>
            <br />
            <p style={{fontSize:"16px"}}>
              The Maker4U's promotional maker allows you to quickly and easily
              turn your brand banner and images into an amazing and powerful
              promotional banner, slideshow, or commercial video that will
              captivate potential customers
            </p>

            <br />
            <p style={{fontSize:"16px"}}>
              Regardless of the target audience for your promo business sales,
              websites, campaigns. Maker4U offers you an extensive library of
              pertinent promotional templates.
            </p>

            <br />
            <p style={{fontSize:"16px"}}>
              Investigate built-in text, effects, intros, outros, and background
              music to elevate your promotional banner to a level befitting a
              professional.
            </p>
          </div>

          <div>
            <LazyLoadImage src="/assets/promotionimage.png" className="w-full h-full object-cover px-4"/>
          </div>
        </div>
      </div>
      <p className=" text-[32px] text-center font-[500] mt-10">
        A Wide Range of Outstanding Promotion Templates for Free
      </p>

      <div className="flex justify-center ">
        <div className="text-center py-4" style={{ maxWidth: "840px", }}>
          <p style={{fontFamily:"poppins", fontSize:"16px" }}>
            This is the perfect place to be if you need an image or video for
            your website, social networking, company promotion, or
            advertisements! We have an extensive collection of well-created
            image and video templates. We can help with everything from social
            media postings to website promotions and marketing clips.
          </p>
        </div>
      </div>
      <div
        className="card-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.map((item) => (
          <NavLink
            to={`/ResumeMaker/temp/${item?.id}`}
            className="hover:no-underline"
          >
            <Card sx={{ maxWidth: 225 }}>
              <CardMedia
                component="img"
                alt="green iguana"
                height="120"
                image={`${api.API_URL}/aapi/templetes/${item.imagepath}`}
              />
              <CardContent
                className=" m-0 h-8 pb-3 text-left font-medium"
                style={{ fontFamily: "poppins" }}
              >
                <Typography gutterBottom variant="h8" component="div">
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </NavLink>
        ))}
      </div>

    
      <div className="flex items-center justify-center w-full">
      <NavLink
          to="/resumeMaker/temp/Promotion Maker"
      >
        <Button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
            width: "180px",
            color: "white",
            borderRadius: "30px",
            backgroundColor:
              "#882ED8",
          }}
        >
          SHOW MORE
        </Button>

        </NavLink>
      </div>

      <p className="my-16 text-[32px] text-center font-[500]">
        Only marketing media maker your brand will ever require!
      </p>

      <div className="imageGrid">
        <div>
          <LazyLoadImage src={`${img}`} />
        </div>
        <div>
          <div onClick={() => setImg(`${img1}`)}>
            <LazyLoadImage src={`${img1}`} />
          </div>
          <div onClick={() => setImg(`${img2}`)}>
            <LazyLoadImage src={`${img2}`} />
          </div>
          <div onClick={() => setImg(`${img3}`)}>
            <LazyLoadImage src={`${img3}`} />
          </div>
        </div>
      </div>

      <div className="catelogTextContainer py-5">
        <div className="w-[1000px] gap-4 text-center mx-auto flex flex-col text-[17px]" >
          <p className="mb-2">
            Get into the festive mood with a professionally produced advertising
            banner. Tell viewers why giving your items as gifts to friends and
            family for the holidays will be a fantastic idea.
          </p>
          <p className="mb-2">
            You can also create 15-second video ads and give your audience a
            taste of your offering. A brief product introduction gives your
            viewers enough information to grab their attention and persuade them
            to click through.
          </p>
          <p style={{fontSize:"16px"}}>
            An effective marketing promotional flyer or banner allows all
            audiences to recognize your business immediately, and Maker4U is the
            simplest stop to create one.
          </p>
          {/* <Button
            onClick={handleOpen}
            style={{
              marginTop: "10px",
              color: "white",
              width: "180px",
              borderRadius: "30px",
              background:
                "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%",
            }}
          >
            Try Now
          </Button> */}
        </div>
      </div>

      <div className="catlogSection">
        <div>
          <LazyLoadImage src={`${img4}`} />
        </div>
        <div></div>
        <div >
          <p>Make Innovative Marketing Campaigns to Boost Sales</p>
          <p style={{fontSize:"16px"}}>
            A sales banner must be imaginative enough to draw viewers in and
            make a lasting impression. An effective marketing promotional banner
            allows all audiences to recognize your business immediately, and
            Maker4U is the simplest website to create one. Create buzz about the
            event and encourage people to come with a promo. Direct visitors
            from a business promotion banner to a sign-up page in only a few
            seconds.
          </p>
          {/* <Button
            onClick={handleOpen}
            style={{
              marginTop: "10px",
              color: "white",
              width: "180px",
              borderRadius: "30px",
              background:
                "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%",
            }}
          >
            Try Now
          </Button> */}
        </div>
      </div>

      <div className="catlogSectionTwo">
        <div>
          <LazyLoadImage src={`${img5}`} />
        </div>
        <div></div>
        <div>
          <p>Create Engaging Advertisements to Expand Brands</p>
          <p style={{fontSize:"16px"}}>
            Make your viewers feel involved, and they will be more inclined to
            learn and convert if you make your Ad pictures entertaining. There
            is no better approach to promote your values and develop your brand
            than through a unique business promotion clip. With the aid of
            Maker4U, you can create cinematic Ads for Twitter, Facebook,
            YouTube, and other platforms.
          </p>
          {/* <Button
            onClick={handleOpen}
            style={{
              marginTop: "10px",
              color: "white",
              width: "180px",
              borderRadius: "30px",
              background:
                "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%",
            }}
          >
            Try Now
          </Button> */}
        </div>
      </div>

      <div className="catelogAITexContainer">
        <div className="catelogAIText">
          <p>Make Eye-Catching Videos to Promote and Market Your Business.</p>
          <p style={{fontSize:"16px"}}>
            Make visually appealing graphics in a matter of minutes! Maker4U's
            promo creator provides hundreds of professionally designed promotion
            templates that anybody can easily edit in minutes. No prior design
            knowledge is required.
          </p>
        </div>
      </div>

      <div className="cardContainer">
        <div>
          <div>
            <LazyLoadImage src={`${img7}`} />
          </div>
          <div>
            <p>1. Include Media </p>
            <p style={{fontFamily:"poppins", fontWeight:"400", fontSize:"16px"}}>
              Compile images or movies from stock libraries or computers into
              the scenario. Add some effects if you like as well.
            </p>
          </div>
        </div>

        <div>
          <div>
            <LazyLoadImage src={`${img8}`} />
          </div>
          <div>
            <p>2. Personalize</p>
            <p style={{fontFamily:"poppins", fontWeight:"400", fontSize:"16px"}}>
              For more customization, add narration, music, and text to your
              advertisement. Choose different styling fonts and bright colors.
            </p>
          </div>
        </div>

        <div>
          <div>
            <LazyLoadImage src={`${img9}`} />
          </div>
          <div>
            <p>3. Export </p>
            <p style={{fontFamily:"poppins", fontWeight:"400", fontSize:"16hpx"}}>
              You may share your promotional media on the internet or download
              it in different resolutions and ratios by clicking the download
              option and exporting it to your computer or sharing it on any
              platform.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Catelog;
